<div class="top-bar-display">
  <div class="top-bar-display__left">
    <div class="top-bar-display__left__menu" (click)="toggleSideBar()">
      @if (sideBarOpened) {
        <ftr-icon icon="Close" align="Middle"></ftr-icon>
      } @else {
        <ftr-icon icon="Menu" align="Middle"></ftr-icon>
      }
    </div>
    New Breadcrumb
  </div>
  <ftr-account-dropdown></ftr-account-dropdown>
</div>
